import React, { useContext, useEffect, useState } from 'react'
import { MdBookmarkAdd, MdBookmarkAdded } from "react-icons/md";
import PieChart from './../components/PieChart';
import Barchart from './../components/Barchart';
import HighChartPie from './../components/HighChartPie';
import HighChartBarCategories from './../components/HighChartBarCategories';
import HighChartBar from './../components/HighChartBar';
import HighChartColumn from './../components/HighChartColumn';
import DataContext from '../context/DataContext';
import { getMonitorStats } from '../api/axiosDashboards';
import { capitalizeFirstLetter } from '../utilities/UtilityFunctions';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useMediaQuery } from 'react-responsive';
import { calculateFontSize } from './../utilities/calculateFontSize';
import { useTranslation } from 'react-i18next'; 
import { getAllCountries } from '../api/axiosCountries';
import { getCountryRegions } from '../api/axiosRegions';
import { getAllRoles } from '../api/axiosRoles';


const HomeMonitor = () => {
  const [monitorStats, setMonitorStats] = useState([]);
  const [pieData, setPieData] = useState([
    { name: 'Monitor Portal', y: 0 },
    { name: 'SMS', y: 0 }
  ]);
  const [barData, setBarData] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [latestComments, setLatestComments] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const { auntheticatedUser, setFetcherror,language ,setRoles,setCountries,setRegions} = useContext(DataContext);
  const user_id = auntheticatedUser?.id;
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ query: '(max-width: 969px)' })
  
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      
      try {

        await getAllCountries(setCountries, setFetcherror, (data, error) => {
          if (data) {
            getCountryRegions(setRegions, setFetcherror, (data?.find((c) => c.name === "TANZANIA"))?.id);
          }
        });
        await getAllRoles(setRoles, setFetcherror, (data, error) => {
          if (data) {
          //  console.log("roles", data);
          }
        });
        
        const response = await getMonitorStats(setMonitorStats, user_id, setFetcherror);
        setPieData([
          { name: 'Monitor Portal', y: +(response.currentMonthIncidentsCount?.isValid) || 0  },
          { name: 'SMS', y: response.currentMonthIncidentsCount?.sms || 0 },
        ]);

        setColumnData(response?.incidentsByRight?.map(item => ({
          name: capitalizeFirstLetter(item.right),
          value: parseInt(item.isValid)
        })));

        setBarData(response?.incidentsByCategory?.map(item => ({
          name: capitalizeFirstLetter(item.category),
          value: parseInt(item.isValid)
        })));

        setLatestComments(response?.latestComments);
      } catch (error) {
        console.error('Failed to fetch dashboard data:', error);
      }
    };

    fetchData();
  }, []);

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const monthsSw = ["Januari", "Februari", "Machi", "Aprili", "Mei", "Juni", "Julai", "Agosti", "Septemba", "Oktoba", "Novemba", "Desemba"];
  let newdate = new Date();
  let month = newdate.getMonth();
  let year = newdate.getFullYear();
  let hometitle = ` ${t('INCIDENTS DASHBOARD')} - ${language === "TZ" ? monthsSw[month] : months[month]} ${year}`



  // Inline styles for the chart containers
  const chartContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    backgroundColor: '#FFF',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.25)',
    borderBottom: '1px solid #f8f9fa',
    padding: '30px 0',
    borderRadius: '4px',
    marginBottom: '25px'
  };

  const mobileChartContainerStyle = {
    ...chartContainerStyle,
    padding: '10px 0'
  };

  const tableContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    padding: '1rem',
    boxSizing: 'border-box',
    backgroundColor: '#FFF',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.25)',
    borderBottom: '1px solid #f8f9fa',
    borderRadius: '4px',
    marginBottom: '25px'
  };

  const tableTitleStyle = {
    fontSize: '1rem',
    fontWeight: '600',
    marginBottom: '0.9rem',
    marginTop: '0.9rem',
    color: '#333',
    textAlign: 'center'
  };

  return (
    <div style={{ paddingRight: '10px', paddingLeft: '10px' }}>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'row', 
        alignContent: 'center', 
        justifyContent: 'center', 
        marginTop: '20px', 
        marginBottom: '20px',
        fontSize: `${calculateFontSize(screenWidth, 24, 16)}px`, 
        fontWeight: '600', 
        color: '#41A6D7' 
      }}>
        {hometitle}
      </div>
      
      <div className="layout-dashboard">
        <div className="grid">
          <div className="col-12 md:col-6 xl:col-3">
            <div className="cardWG grid-nogutter widget-overview-box widget-overview-box-1">
              <span className="overview-icon">
                <i className="pi pi pi-bars"></i>
              </span>
              <span className="overview-title">{t('All Incidents')}</span>
              <div className="grid overview-detail">
                <div className="col-6">
                  <div className="overview-number">{monitorStats?.allIncidentsCount?.total || 0}</div>
                  <div className="overview-subtext">{t('Submitted')}</div>
                </div>
                <div className="col-6">
                  <div className="overview-number">{monitorStats?.allIncidentsCount?.isValid || 0}</div>
                  <div className="overview-subtext">{t('Valid')}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-6 xl:col-3">
            <div className="cardWG grid-nogutter widget-overview-box widget-overview-box-2">
              <span className="overview-icon">
                <i className="pi pi-inbox"></i>
              </span>
              <span className="overview-title"> {language === "TZ" ? `${t('Incidents')} Ya ${monthsSw[month]} ${year}`: `${months[month]} ${year} ${t('Incidents')}`}</span>
              <div className="grid overview-detail">
                <div className="col-6">
                  <div className="overview-number">{monitorStats?.currentMonthIncidentsCount?.total || 0}</div>
                  <div className="overview-subtext">{t('Submitted')}</div>
                </div>
                <div className="col-6">
                  <div className="overview-number">{monitorStats?.currentMonthIncidentsCount?.isValid || 0}</div>
                  <div className="overview-subtext">{t('Valid')}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-6 xl:col-3">
            <div className="cardWG grid-nogutter widget-overview-box widget-overview-box-3">
              <span className="overview-icon">
                <i className="pi pi-users"></i>
              </span>
              <span className="overview-title"> {language === "TZ" ? `${t('Follow-ups')}  ${monthsSw[month]} ${year}`: `${months[month]} ${year} ${t('Follow-ups')}`}</span>
              <div className="grid overview-detail">
                <div className="col-6">
                  <div className="overview-number">{monitorStats?.currentMonthCommentsCount?.total || 0}</div>
                  <div className="overview-subtext">{t('Submitted')}</div>
                </div>
                <div className="col-6">
                  <div className="overview-number">{monitorStats?.currentMonthCommentsCount?.isValid || 0}</div>
                  <div className="overview-subtext">{t('Accepted')}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-6 xl:col-3">
            <div className="cardWG grid-nogutter widget-overview-box widget-overview-box-4">
              <span className="overview-icon">
                <i className="pi pi-sort-amount-up-alt"></i>
              </span>
              <span className="overview-title"> {language === "TZ" ? `${t('Airtime')}  ${monthsSw[month]} ${year}`: `${months[month]} ${year} ${t('Airtime')}`}</span>
              <div className="grid overview-detail">
                <div className="col-6">
                  {(monitorStats?.currentMonthIncidentsCount?.isValid) > 0 ?
                    <div className="overview-number text-green-600">{t('YES')}</div>
                    :
                    <div className="overview-number text-red-600">{t('NO')}</div>
                  } 
                  <div className="overview-subtext">{t('Qualified')}</div>
                </div>
                <div className="col-6">
                  <div className="overview-number text-red-600">{auntheticatedUser?.district}</div>
                  <div className="overview-subtext">{t('My Disctrict')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Charts Section using PrimeFlex Grid */}
      <div className="grid" style={{ marginTop: '25px' }}>
        {/* Row 1 */}
        <div className="col-12 md:col-6">
          <div style={isMobile ? mobileChartContainerStyle : chartContainerStyle}>
            <HighChartPie 
              chartData={pieData} 
              chartName={t('My Valid Incident Sources')} 
              className="charCanvas" 
            />
          </div>
        </div>
        
        <div className="col-12 md:col-6">
          <div style={isMobile ? mobileChartContainerStyle : chartContainerStyle}>
            <HighChartColumn 
              chartData={columnData} 
              chartName={t('My Incidents per Right Violated')} 
              xAxis={t('Rights Violated')} 
              yAxis={t('# of Incidents')} 
              className="charCanvas"
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="col-12 md:col-6">
          <div style={isMobile ? mobileChartContainerStyle : tableContainerStyle}>
            <div style={tableTitleStyle}>{t('Latest Follow-ups')}</div>
            <DataTable 
              className="homeMonitor-table-wrapper"
              value={latestComments}
              showGridlines
              emptyMessage={t('No Follow-ups')}
              style={{ width: '100%' }}
            >
              <Column header={t("S/N")} body={(rowData) => latestComments?.indexOf(rowData) + 1} />
              <Column header={t("IncidentNumber")} body={(rowData) => rowData?.incidentNumber} />
              <Column header={t("Followup")} body={(rowData) => rowData?.comment} />
            </DataTable>
          </div>
        </div>
        
        <div className="col-12 md:col-6">
          <div style={isMobile ? mobileChartContainerStyle : chartContainerStyle}>
            <HighChartBar 
              chartData={barData} 
              chartName= {t('My Incidents per Category')} 
              xAxis={t('Categories')} 
              yAxis={t('# of Incidents')} 
              className="charCanvas"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeMonitor